import { ArrowRight } from '@travel/icons/ui';

import { useDispatch } from 'react-redux';
import { pushLocation } from 'favoriteList/store/__router/actions';

import paths from 'favoriteList/core/universalRouter/paths';

import {
  FAVORITE_PAGE_TITLE_DOMESTIC,
  FAVORITE_PAGE_TITLE_OVERSEAS,
  FAVORITE_DOMESTIC_LINK_TEXT,
  FAVORITE_OVERSEAS_LINK_TEXT,
} from 'favoriteList/constants/common';

import styles from './pagetitle.module.scss';

type PageTitleProps = {
  isSP: boolean;
  isDomestic: boolean;
  isPlanList: boolean;
};

const PageTitle = (props: PageTitleProps) => {
  const { isSP, isDomestic, isPlanList } = props;

  const dispatch = useDispatch();

  const linkHandler = () => {
    dispatch(
      pushLocation({
        pathname: path,
      }),
    );
  };

  const path = isDomestic
    ? isPlanList
      ? paths.overseasPlan.path
      : paths.overseasProvider.path
    : isPlanList
      ? paths.domesticPlan.path
      : paths.domesticProvider.path;

  return (
    <div className={isSP ? styles.containerSP : styles.container}>
      <div className={styles.title}>
        <span>{isDomestic ? FAVORITE_PAGE_TITLE_DOMESTIC : FAVORITE_PAGE_TITLE_OVERSEAS}</span>
      </div>
      <button className={styles.favoriteListLink} onClick={linkHandler}>
        <span>{isDomestic ? FAVORITE_OVERSEAS_LINK_TEXT : FAVORITE_DOMESTIC_LINK_TEXT}</span>
        <ArrowRight size={12} />
      </button>
    </div>
  );
};

export default PageTitle;
